import compat from '../common/compat';
import ProductDiscussionModal from './components/ProductDiscussionModal';


export default Object.assign(compat, {
  'ruko/components/ProductDiscussionModal': ProductDiscussionModal,
});
